<script setup lang="ts">
import { PropType } from 'vue';

defineProps({
  label: {
    type: String,
  },
  errors: {
    type: Object as PropType<{ _errors: string[] }>,
  },
  limitWidth: {
    type: Boolean,
    default: true,
  },
  isRequired: {
    type: Boolean,
  },
  useFullWidth: {
    type: Boolean,
  },
  useVerticalStack: {
    type: Boolean,
  },
  maxLength: {
    type: Number,
  },
});

const id = 'id' + Math.random().toString(16).slice(2);
</script>

<template>
  <div class="flex items-center py-[6px]" :class="{ 'col-span-2': useFullWidth, 'flex-col': useVerticalStack }">
    <label
      v-if="label && useVerticalStack"
      class="w-full text-left text-[14px] text-gray-700 dark:text-slate-400 !font-semibold pb-1"
      :for="id"
    >
      {{ $t(label) }} <span class="-ml-[3px]" v-if="isRequired">*</span>
    </label>

    <label
      class="min-w-[215px] max-w-[215px] text-[14px] text-gray-700 dark:text-slate-400 !font-semibold pb-1"
      :for="id"
      v-else-if="label"
      >{{ $t(label) }} <span class="-ml-[3px]" v-if="isRequired">*</span>
    </label>
    <div class="w-full flex flex-col" :class="{ '2xl:flex-row': limitWidth }">
      <div class="flex flex-row grow" :class="{ 'max-w-[600px]': limitWidth }">
        <slot :id="id"></slot>
      </div>
    </div>
  </div>
  <div v-if="!!errors?._errors?.length" class="text-red-800 text-[12.5px] ml-1">
    <span v-for="error in errors?._errors"> {{ $t(error) }}</span>
  </div>
</template>
